import { useEffect } from "react";

import { useCardFunc } from "../../hooks";

import { SimpleGrid, Heading } from "@chakra-ui/react";

import { AlertCard } from "../../components/Cards/AlertCard";

export const AlertPalette = () => {
  let defaultAlertCard = [
    { id: 0, num: 1, cardName: "Success", cardValue: "#37C976" },
    { id: 1, num: 2, cardName: "Info", cardValue: "#3EAFFF" },
    { id: 2, num: 3, cardName: "Warning", cardValue: "#FFA23A" },
    { id: 3, num: 4, cardName: "Danger", cardValue: "#FE5051" },
  ];

  const {
    card,
    setCard,
    addCard,
    deleteCard,
    handleNameChange,
    handleColorChange,
  } = useCardFunc(defaultAlertCard, {
    cardName: "Alert",
    cardValue: "#3EAFFF",
  });

  let n = card.length;

  // Saving State Logic
  useEffect(() => {
    let data = localStorage.getItem("AlertPalette");
    if (data) {
      setCard(JSON.parse(data));
    }
  }, [setCard]);

  useEffect(() => {
    localStorage.setItem("AlertPalette", JSON.stringify(card));
  });

  return (
    <>
      <Heading
        fontSize="40px"
        fontWeight="medium"
        fontFamily="Ubuntu"
        lineHeight="40px"
        color="#131215"
        mt="64px"
        mb="24px"
      >
        Alert
      </Heading>
      <SimpleGrid
        columns={{ md: 2, lg: 3 }}
        spacingX="20px"
        spacingY="28px"
        mb="32px"
      >
        {card.map((val) => {
          return (
            <AlertCard
              colorCode={val.cardValue}
              id={val.id}
              num={val.num}
              deleteCard={() => deleteCard(val.id)}
              name={val.cardName}
              handleNameChange={handleNameChange}
              handleColorChange={handleColorChange}
            />
          );
        })}
        {card[n - 1].num === 9 ? "" : <AlertCard create addCard={addCard} />}
      </SimpleGrid>
    </>
  );
};
